// eslint-disable-next-line no-unused-vars
import { useState, useEffect, useMemo } from 'react'
import { TemplateService, ErrorConstant } from 'utility'

// export const GetPublicTemplateList = () => {
//     const [data, setData] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState(null)
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 20,
//         SearchText: '',
//         CategoryId: 0,
//         SortBy: 0,
//     })
//     const [totalCount, setTotalCount] = useState(0)
//     const options = useMemo(
//         () =>
//             data.map(ele => ({
//                 value: ele.Id,
//                 text: ele.TemplateName,
//             })),
//         [data],
//     )

//     const fetchData = async () => {
//         setError(null)
//         try {
//             setLoading(true)
//             // const response = await TemplateService.getPublicTemplateList(filter)
//             const result = await TemplateService.getPublicTemplateList(
//                 !filter.all ? filter : { ...filter, PageSize: 5000000 },
//             )
//             setData(result.Items)
//             setTotalCount(result.TotalCount)

//         } catch (err) {
//             // eslint-disable-next-line no-undef
//             setError(ErrorConstant.default)
//         } finally {
//             setLoading(false)
//         }
//     }

//     useEffect(() => {
//         fetchData()
//     }, [filter])

//     const pageChanged = pageNumber => {
//         setFilter(prev => ({ ...prev, PageNumber: pageNumber }))
//     }

//     const filterChanged = newFilter => {
//         setFilter(prev => ({ ...prev, ...newFilter, PageNumber: 1 }))
//     }

//     return {
//         data,
//         setData,
//         loading,
//         error,
//         filter,
//         totalCount,
//         pageChanged,
//         filterChanged,
//         options,
//     }
// }
// export const GetPublicTemplateList = () => {
//     const [data, setData] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState(null)
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 20,
//         SearchText: '',
//         CategoryId: 0,
//         SortBy: 0,
//     })
//     const [totalCount, setTotalCount] = useState(0)

//     const options = useMemo(
//         () =>
//             data.map(ele => ({
//                 value: ele.Id,
//                 text: ele.TemplateName,
//             })),
//         [data],
//     )
//     const formatDescription = description => {
//         if (!description) return 'Description unavailable'
//         return description
//             .match(/.{1,20}/g) // Splits the description into chunks of 20 characters
//             .join('\n') // Joins the chunks with a newline
//     }

//     const fetchData = async () => {
//         setError(null)
//         try {
//             setLoading(true)
//             console.log('Fetching template list...')
//             const result = await TemplateService.getPublicTemplateList(filter)

//             const templatesWithDetails = await Promise.all(
//                 result.Items.map(async template => {
//                     const templateId = template.Id || template.TemplateId
//                     if (!templateId) {
//                         console.warn(
//                             'Template ID is missing or undefined:',
//                             template,
//                         )
//                         return {
//                             ...template,
//                             TemplateDescription: formatDescription(
//                                 'Description unavailable',
//                             ),
//                         }
//                     }
//                     try {
//                         // console.log(
//                         //     'Fetching details for template ID:',
//                         //     templateId,
//                         // )
//                         // const details =
//                         //     await TemplateService.getPublicTemplateDetails(
//                         //         templateId,
//                         //     )
//                         return {
//                             ...template,
//                             TemplateDescription: 'Description unavailable',
//                         }
//                     } catch (err) {
//                         console.error(
//                             'Error fetching details for template ID:',
//                             templateId,
//                             err,
//                         )
//                         return {
//                             ...template,
//                             TemplateDescription: 'Description unavailable',
//                         }
//                     }
//                 }),
//             )

//             setData(templatesWithDetails)
//             setTotalCount(result.TotalCount)
//         } catch (err) {
//             console.error('Error fetching template list:', err)
//             setError('An error occurred while fetching template data.')
//         } finally {
//             setLoading(false)
//         }
//     }

//     useEffect(() => {
//         fetchData()
//     }, [filter])
//     const pageChanged = pageNumber => {
//         setFilter(prev => ({ ...prev, PageNumber: pageNumber }))
//     }

//     const filterChanged = newFilter => {
//         setFilter(prev => ({ ...prev, ...newFilter, PageNumber: 1 }))
//     }
//     return {
//         data,
//         setData,
//         loading,
//         error,
//         filter,
//         totalCount,
//         pageChanged,
//         filterChanged,
//         options,
//     }
// }

export const GetPublicTemplateList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: 20,
        SearchText: '',
        CategoryId: 0,
        SortBy: 0,
    })
    const [totalCount, setTotalCount] = useState(0)

    const options = useMemo(
        () =>
            data.map(ele => ({
                value: ele.Id,
                text: ele.TemplateName && ele.Category,
            })),
        [data],
    )

    const fetchData = async () => {
        setError(null)
        try {
            setLoading(true)
            console.log('Fetching data with filter:', filter) // Debug API call
            const result = await TemplateService.getPublicTemplateList(filter)
            console.log('Fetched result:', result) // Log the API response

            const templatesWithDetails = result.Items.map(template => ({
                ...template,
                TemplateDescription:
                    template.TemplateDescription || 'Description unavailable',
            }))
            console.log('Processed templates:', templatesWithDetails) // Log processed data
            setData(templatesWithDetails)
            setTotalCount(result.TotalCount)
        } catch (err) {
            console.error('Error fetching template list:', err)
            setError('An error occurred while fetching template data.')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [filter])

    const pageChanged = pageNumber => {
        setFilter(prev => ({ ...prev, PageNumber: pageNumber }))
    }

    const filterChanged = newFilter => {
        setFilter(prev => ({ ...prev, ...newFilter, PageNumber: 1 }))
    }

    return {
        data,
        setData,
        loading,
        error,
        filter,
        totalCount,
        pageChanged,
        filterChanged,
        options,
    }
}

export const GetPublicTempleteDetails = (templateId, options = {}) => {
    const [data, setData] = useState('')
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const fetchData = async () => {
        try {
            setLoading(true)
            const result = await TemplateService.getPublicTemplateDetails(
                templateId,
                options,
            )
            setData(result || {})
        } catch {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }
    console.log(data.TemplateDescription)
    useEffect(() => {
        if (templateId) {
            fetchData()
        }
    }, [templateId])

    return { data, error, loading, setData }
}

export const GetPublicTemplateTypeDetails = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await TemplateService.getPublicTemplateType()
                setData(
                    (result?.Items || []).map(data => ({
                        value: data.Id,
                        text: data.TemplateType,
                        name: data.TemplateType,
                    })),
                )
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    return { data, error, loading }
}
export const GetsortBy = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await TemplateService.getsortBy()
                setData(
                    (result || []).map(data => ({
                        value: data.SortById,
                        text: data.SortByName,
                        name: data.SortByName,
                    })),
                )
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    return { data, error, loading }
}
